@let isBot = bet()?.steamid === '-1';
<div class="wrapper">
  <div
    class="player"
    [class.opacity-30]="
      coinflip().fe_status === 'finished' &&
      coinflip().winner?.side !== bet()?.side &&
      !showAnimation()
    "
  >
    <div
      class="player-avatar"
      [class.events-none]="!bet() || bet()?.steamid === '-1'"
      [class.filter-grayscale]="
        bet()?.reveral || (coinflip().fe_status === 'joining' && !isHost())
      "
      [class.player-avatar_blue]="
        bet()?.side === coinflip().host.side
          ? coinflip().host.side === 1
          : coinflip().host.side === 2
      "
      [class.player-avatar_red]="
        bet()?.side === coinflip().host.side
          ? coinflip().host.side === 2
          : coinflip().host.side === 1
      "
      [class.player-avatar_filter__blue]="
        !showAnimation() &&
        bet()?.side === 1 &&
        bet()?.steamid === coinflip().winner?.steamid
      "
      [class.player-avatar_filter__red]="
        !showAnimation() &&
        bet()?.side === 2 &&
        bet()?.steamid === coinflip().winner?.steamid
      "
      [style.cursor]="isBot || !bet() ? 'default' : 'pointer'"
      (click)="
        isBot || !bet()
          ? null
          : contextMenuService.open($event, { user: bet()! })
      "
    >
      @if (bet()) {
      <img
        width="80"
        height="80"
        class="player-avatar_avatar"
        [class.filter-grayscale]="
          bet()?.reveral || (coinflip().fe_status === 'joining' && !isHost())
        "
        [src]="bet()!.avatar"
        [alt]="bet()!.name"
      />
      <app-coinflip-coin
        class="player-avatar_icon"
        [side]="bet()!.side"
        [size]="'28px'"
      ></app-coinflip-coin>
      <!-- @if (bet()?.reveral) {
      <app-dots-loader
        style="isolation: isolate; filter: contrast(2)"
        [width]="60"
        class="player-avatar_reveral"
        icon
      ></app-dots-loader>
      }  -->

      } @if (!bet()) {
      <span
        class="player-avatar_placeholder"
        [class.player-avatar_placeholder__blue]="coinflip().host.side === 2"
        [class.player-avatar_placeholder__red]="coinflip().host.side === 1"
      >
        <img
          class="loader"
          src="assets/old-images/loading.png"
          [src]="
            coinflip().host.side === 2
              ? 'assets/old-images/loader_blue_icon.png'
              : 'assets/old-images/loader_red_icon.png'
          "
          alt="loading"
        />
      </span>
      }
    </div>
    <div
      class="player-name"
      [class.filter-grayscale]="
        bet()?.reveral || (coinflip().fe_status === 'joining' && !isHost())
      "
      [style.cursor]="isBot || !bet() ? 'default' : 'pointer'"
      (click)="
        isBot || !bet()
          ? null
          : contextMenuService.open($event, { user: bet()! })
      "
    >
      @if (bet()?.steamid === '-1') { @if (bet()?.steamid === '-1') {
      <span class="bot-badge">bot</span>
      }
      <span class="typography-name">
        {{ bet()?.name?.replace("[BOT]", "") }}
      </span>
      } @if (bet() && bet()!.steamid !== '-1') {
      <span class="typography-name">
        {{ bet()!.name }}
      </span>
      } @if (!bet()) {
      <span class="dots-animation player-name_placeholder typography-name"
        >Waiting for player</span
      >
      }
    </div>
    <div
      class="player-info"
      [class.filter-grayscale]="
        bet()?.reveral || (coinflip().fe_status === 'joining' && !isHost())
      "
    >
      <div
        class="badge"
        [class.gray]="!bet()"
        [class.blue]="bet()?.side === 1"
        [class.red]="bet()?.side === 2"
      >
        <app-cost
          [cost]="bet()?.value ?? 0"
          [balanceType]="coinflip().is_pure ? 'pure' : 'skins'"
          [gap]="4"
          [color]="
            bet()?.side === 1
              ? 'var(--blue)'
              : bet()?.side === 2
              ? 'var(--red)'
              : 'var(--gray)'
          "
        />
      </div>
      <div class="badge gray">{{ bet()?.chance ?? 0 }}%</div>
      <div class="badge gray player-info_skins">
        <svg-icon
          class="flex items-center justify-center s-24"
          src="assets/icons/shared/skins-quantity.svg"
          [svgStyle]="{ width: '16px', height: '16px' }"
        />
        {{ filteredSkins().length }}
      </div>
    </div>
  </div>
  <div
    class="skins-container"
    [class.tf2hunt--skins-shadow]="filteredSkins().length > 0"
    [class.skins-container_left]="coinflip().host.steamid === bet()?.steamid"
    [class.skins-container_right]="coinflip().host.steamid !== bet()?.steamid"
    [class.opacity-30]="
      coinflip().fe_status === 'finished' &&
      coinflip().winner?.side !== bet()?.side &&
      !showAnimation()
    "
    [class.filter-grayscale]="
      bet()?.reveral || (coinflip().fe_status === 'joining' && !isHost())
    "
  >
    @if (filteredSkins().length > 0) {
    <app-skins-list
      class="skins"
      [config]="{
        skin_min_width: '100px',
        mobile: {
          skin_min_width: '140px',
          padding: '8px',
        },
      }"
      [skins]="filteredSkins()"
      [balanceType]="coinflip().is_pure ? 'pure' : 'skins'"
    ></app-skins-list>
    } @else {
    <div class="col-span_full buttons">
      @if (!bet() && coinflip().host.steamid !== session.profile()?.steamid) {

      <button
        class="button button--style-yellow padding-x-12 h-40 create"
        [class.pure]="coinflip().is_pure"
        (click)="openJoinModal()"
      >
        <app-game-icon color="black" [game]="'Coinflip'"></app-game-icon>
        Join {{ coinflip().is_pure ? "Pure" : null }} Coinflip
      </button>
      }
      <!--  -->
      @if (!bet() && coinflip().host.steamid === session.profile()?.steamid) {
      <button
        class="button button--style-yellow padding-x-12 h-40 create"
        [class.pure]="coinflip().is_pure"
        (click)="callBot()"
      >
        <svg-icon
          class="flex items-center justify-center s-24"
          src="assets/icons/shared/profile.svg"
          [svgStyle]="{ fill: 'black', width: '16px', height: '16px' }"
        />
        Call bot
      </button>
      }
      <!--  -->
      @if (coinflip().status === 'open' && (coinflip().host.steamid ===
      session.profile()?.steamid || session.is_admin())) {

      <button
        (click)="cancelCoinflip()"
        style="filter: grayscale(1)"
        class="button button--style-yellow padding-x-12 h-40 cancel"
      >
        Cancel coinflip
      </button>
      }
      <!--  -->
      @if (bet() && bet()!.side !== coinflip().host.side && coinflip().status
      === 'joining') {

      <button class="button button--style-white-04 padding-x-12 h-40 joining">
        <img
          class="s-24 rounded-full"
          style="object-fit: cover"
          [src]="coinflip().part?.avatar"
          [alt]="coinflip().part?.name"
        />
        Joining
        <span style="width: 30px">
          @if (coinflip().end) {
          <countdown
            #cd
            @fadeInAnimation
            class="countdown"
            [config]="{ stopTime: coinflip().end! * 1000, format: 'ss' }"
          />
          }
        </span>
      </button>
      }
      <!--  -->
    </div>
    }
  </div>
</div>
